export interface CategoryView {
  id: number;
  parentId: number | null;
  name: string;
  name_cn?: string | null;
  nameCn?: string | null;
  sortOrder: number;
}

export interface CategoryTreeNode extends CategoryView {
  children: CategoryTreeNode[];
}

export function categoryDisplayName(category: CategoryView): string {
  return category.name_cn || category.nameCn || category.name;
}
